import { TouchableOpacity, View } from "react-native";
import IonIcons from "react-native-vector-icons/Ionicons";

interface ButtonIconProps {
  onPress: () => void;
  name: string | "home";
  size?: number | 48;
  color?: string | "#000";
  padding?: number | 0;
}

export default function ButtonIcon(props: ButtonIconProps) {
  return (
    <View
      style={{
        margin: props.padding,
      }}
    >
      <TouchableOpacity onPress={props.onPress}>
        <View
          style={{
            width: props.size,
            height: props.size,
          }}
        >
          <IonIcons name={props.name} size={props.size} color={props.color} />
        </View>
      </TouchableOpacity>
    </View>
  );
}
